var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "item-name" },
    [
      _vm._v("\n    " + _vm._s(_vm.name_object.name) + "\n    "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.name_object.value,
            expression: "name_object.value",
            modifiers: { lazy: true }
          }
        ],
        staticClass: "name_input",
        attrs: {
          type: "text",
          placeholder: "名称定义",
          autofocus: "",
          onfocus: "this.select()"
        },
        domProps: { value: _vm.name_object.value },
        on: {
          change: function($event) {
            return _vm.$set(_vm.name_object, "value", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _vm.editable
        ? _c(
            "bay-item-edit",
            _vm._g(
              { staticClass: "edit-show", attrs: { index: _vm.index } },
              _vm.$listeners
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }